export default "__VITE_ASSET__CgeHHacB__"